(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1753],{

/***/ 2092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCallbackRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */

function useCallbackRef() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
}

/***/ }),

/***/ 1176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useEventCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = (0,react.useRef)(value);
  (0,react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ var esm_useCommittedRef = (useCommittedRef);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js


function useEventCallback(fn) {
  var ref = esm_useCommittedRef(fn);
  return (0,react.useCallback)(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/***/ }),

/***/ 6454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */

function useMounted() {
  var mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () {
    return mounted.current;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/***/ }),

/***/ 6852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useWillUnmount; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useUpdatedRef.js

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */

function useUpdatedRef(value) {
  var valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js


/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */

function useWillUnmount(fn) {
  var onUnmount = useUpdatedRef(fn);
  (0,react.useEffect)(function () {
    return function () {
      return onUnmount.current();
    };
  }, []);
}

/***/ }),

/***/ 4194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWaitForDOMRef; }
/* harmony export */ });
/* unused harmony export resolveContainerRef */
/* harmony import */ var dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7216);
/* harmony import */ var dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3004);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _useWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2963);




const resolveContainerRef = (ref, document) => {
  if (!dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) return null;
  if (ref == null) return (document || (0,dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()).body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  const window = (0,_useWindow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const [resolvedRef, setRef] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => resolveContainerRef(ref, window == null ? void 0 : window.document));

  if (!resolvedRef) {
    const earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const nextRef = resolveContainerRef(ref);

    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

/***/ }),

/***/ 2963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindow; }
/* harmony export */ });
/* unused harmony export WindowProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3004);


const Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? window : undefined);
const WindowProvider = Context.Provider;
/**
 * The document "window" placed in React context. Helpful for determining
 * SSR context, or when rendering into an iframe.
 *
 * @returns the current window
 */

function useWindow() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
}

/***/ }),

/***/ 424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/***/ }),

/***/ 1132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ hasClass; }
/* harmony export */ });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),

/***/ 1143:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 6132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5444);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5518);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2914);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6968);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3489);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3174);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7579);
/* harmony import */ var _constants_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(934);
/* harmony import */ var _components_atomic_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6668);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);


var _excluded = ["labeled", "noBottomSpace"],
    _excluded2 = ["processing"],
    _excluded3 = ["labeled"],
    _excluded4 = ["labeled"],
    _excluded5 = ["name", "type", "accept", "hint", "label", "loading", "labelSpace", "required", "noBottomSpace", "valid", "invalid", "feedback", "value", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors */ .r.colors,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.spaces */ .r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var labeled = _ref.labeled,
      noBottomSpace = _ref.noBottomSpace,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Group */ .Z.Group, _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BaseInput__StyledGroup",
  componentId: "sc-nlucr6-0"
})(["position:relative;padding-top:", "px;margin-bottom:", "px;", ""], function (_ref2) {
  var labeled = _ref2.labeled;
  return labeled ? spaces.largeX : 0;
}, spaces.regular, function (_ref3) {
  var noBottomSpace = _ref3.noBottomSpace;
  return noBottomSpace && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(["margin-bottom:0;"]);
});
var StyledLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Label */ .Z.Label).withConfig({
  displayName: "BaseInput__StyledLabel",
  componentId: "sc-nlucr6-1"
})(["position:absolute;top:0;left:", "px;margin:0;font-family:'Aeonik';font-size:", "px;font-style:normal;font-weight:400;line-height:150%;color:", ";span{color:", ";}"], spaces.smallest, fontSizes.regular, colors.gray[800], colors.orange[500]); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledControl = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref4, ref) {
  var processing = _ref4.processing,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref4, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Control */ .Z.Control, _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BaseInput__StyledControl",
  componentId: "sc-nlucr6-2"
})(["min-height:48px;padding-top:", "px;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;border:1px solid ", ";border-radius:4px;background-color:", ";font-family:'Aeonik';font-size:", "px;font-style:normal;font-weight:400;line-height:150%;color:", ";caret-color:", ";&::placeholder{color:", ";}&:focus{border-color:", ";box-shadow:none;}&:disabled{background-color:", ";}&.form-control.is-valid{padding-right:", "px;border-color:", ";background-image:none;&:focus{border-color:", ";box-shadow:none;}}&.form-control.is-invalid{padding-right:", "px;border-color:", ";background-image:none;&:focus{border-color:", ";box-shadow:none;}}", ";&::-webkit-file-upload-button{display:none;}"], spaces.small - 2, spaces.small - 2, spaces.regular, spaces.regular, colors.gray[200], colors.white, fontSizes.regular, colors.gray[800], colors.blue[500], colors.gray[400], colors.blue[500], colors.gray[100], spaces.regular, colors.gray[200], colors.blue[500], spaces.regular, colors.orange[800], colors.blue[500], function (_ref5) {
  var processing = _ref5.processing;
  return processing && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(["padding-right:", "px;"], spaces.large6X);
});
var StyledSpinner = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function (_ref6) {
  var labeled = _ref6.labeled,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref6, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, _objectSpread({}, props));
}).withConfig({
  displayName: "BaseInput__StyledSpinner",
  componentId: "sc-nlucr6-3"
})(["position:absolute;top:", "px;right:", "px;&.text-custom{color:", ";}", ""], spaces.largeX + (48 - 32) / 2, spaces.smallX, colors.gray[500], function (_ref7) {
  var labeled = _ref7.labeled;
  return !labeled && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(["top:", "px;"], (48 - 32) / 2);
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledIconContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref8, ref) {
  var labeled = _ref8.labeled,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref8, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BaseInput__StyledIconContainer",
  componentId: "sc-nlucr6-4"
})(["display:flex;position:absolute;top:", "px;right:", "px;", ""], spaces.largeX + (48 - 16) / 2, spaces.regular, function (_ref9) {
  var labeled = _ref9.labeled;
  return !labeled && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(["top:", "px;"], (48 - 16) / 2);
});
var StyledFeedback = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Control.Feedback */ .Z.Control.Feedback).withConfig({
  displayName: "BaseInput__StyledFeedback",
  componentId: "sc-nlucr6-5"
})(["padding-left:", "px;font-family:'Aeonik';font-size:", "px;font-style:normal;font-weight:400;line-height:150%;&.processing-feedback{color:", ";}&.valid-feedback{color:", ";}&.invalid-feedback{color:", ";}"], spaces.smallest, fontSizes.regular, colors.gray[500], colors.blue[500], colors.orange[800]); // eslint-disable-next-line prettier/prettier, react/display-name

var BaseInput = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref10, ref) {
  var name = _ref10.name,
      type = _ref10.type,
      accept = _ref10.accept,
      hint = _ref10.hint,
      label = _ref10.label,
      loading = _ref10.loading,
      labelSpace = _ref10.labelSpace,
      required = _ref10.required,
      noBottomSpace = _ref10.noBottomSpace,
      valid = _ref10.valid,
      invalid = _ref10.invalid,
      feedback = _ref10.feedback,
      value = _ref10.value,
      onChange = _ref10.onChange,
      restProps = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref10, _excluded5);

  var handleChangeFile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (e) {
    var files = e.target.files;
    onChange && onChange({
      target: {
        name: name,
        value: files !== null && files !== void 0 && files.length ? files[0] : null
      }
    });
  }, [name, onChange]);
  var overlayTriggerProps = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var props = {
      placement: react_device_detect__WEBPACK_IMPORTED_MODULE_2__/* .isMobile */ .tq ? 'top' : 'right-start',
      delay: {
        show: 0,
        hide: 0
      },
      trigger: ['hover', 'focus'],
      overlay: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        id: "tooltip-".concat(name),
        className: "hintTooltip",
        children: hint
      })
    };

    if (!hint || react_device_detect__WEBPACK_IMPORTED_MODULE_2__/* .isMobile */ .tq) {
      props.show = false;
    }

    return props;
  }, [name, hint]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, overlayTriggerProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledGroup, {
      labeled: Boolean(label || labelSpace),
      noBottomSpace: noBottomSpace,
      className: invalid ? 'custom-control-invalid' : '',
      children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledLabel, {
        children: [label, label && required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
          children: "\xA0*"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledControl, _objectSpread(_objectSpread({}, restProps), {}, {
        ref: ref,
        type: type,
        accept: accept,
        isValid: valid,
        isInvalid: invalid,
        processing: loading,
        value: type === 'file' ? undefined : value || '',
        onChange: type === 'file' ? handleChangeFile : onChange,
        "data-hj-allow": true
      })), loading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledSpinner, {
          animation: "border",
          variant: "custom",
          labeled: Boolean(label || labelSpace)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledFeedback, {
          type: "processing",
          children: feedback
        })]
      }), type === 'file' && (value === null || value === void 0 ? void 0 : value.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledFeedback, {
        type: "processing",
        children: value.name
      }), !loading && valid && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledIconContainer, {
          labeled: Boolean(label || labelSpace),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            alias: _constants_icons__WEBPACK_IMPORTED_MODULE_4__/* .ICONS_ALIASES.check */ .F.check,
            color: colors.blue[500],
            height: 16,
            width: 16
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledFeedback, {
          type: "valid",
          children: feedback
        })]
      }), !loading && invalid && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledIconContainer, {
          labeled: Boolean(label || labelSpace),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            alias: _constants_icons__WEBPACK_IMPORTED_MODULE_4__/* .ICONS_ALIASES.close */ .F.close,
            color: colors.orange[800],
            height: 16,
            width: 16
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledFeedback, {
          type: "invalid",
          children: feedback
        })]
      }), !loading && !valid && !invalid && type === 'file' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledIconContainer, {
        labeled: Boolean(label || labelSpace),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          alias: _constants_icons__WEBPACK_IMPORTED_MODULE_4__/* .ICONS_ALIASES.link */ .F.link,
          color: colors.gray[500]
        })
      })]
    })
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (BaseInput);

/***/ }),

/***/ 2258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7536);
/* harmony import */ var _components_atomic_controls_BaseInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6132);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["type", "name", "control", "rules", "feedback", "getPaymentProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var BaseField = function BaseField(_ref) {
  var type = _ref.type,
      name = _ref.name,
      control = _ref.control,
      _ref$rules = _ref.rules,
      rules = _ref$rules === void 0 ? {} : _ref$rules,
      feedback = _ref.feedback,
      getPaymentProps = _ref.getPaymentProps,
      restProps = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      selectionTarget = _useState[0],
      setSelectionTarget = _useState[1];

  var handleTextSelect = function handleTextSelect(event) {
    var elem = event.target;
    var selectionLength = elem.selectionEnd - elem.selectionStart;

    if (!selectionLength) {
      setSelectionTarget(null);
    } else {
      setSelectionTarget(elem.name);
    }
  };

  var getPaymentExtraProps = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    if (name === selectionTarget) {
      return {
        onKeyPress: function onKeyPress() {}
      };
    }

    return {};
  }, [selectionTarget, name]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .Controller */ .Qr, {
    name: name,
    control: control,
    rules: rules,
    render: function render(_ref2) {
      var field = _ref2.field,
          error = _ref2.fieldState.error,
          isSubmitted = _ref2.formState.isSubmitted;

      if (getPaymentProps) {
        var onChange = field.onChange,
            onBlur = field.onBlur,
            value = field.value;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_atomic_controls_BaseInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, restProps), {}, {
          valid: isSubmitted && !error,
          invalid: isSubmitted && error,
          feedback: (error === null || error === void 0 ? void 0 : error.message) || feedback
        }, getPaymentProps({
          onChange: onChange,
          onBlur: onBlur,
          value: value
        })), getPaymentExtraProps()), {}, {
          type: type,
          onSelect: handleTextSelect
        }));
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_atomic_controls_BaseInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread(_objectSpread({
        type: type
      }, restProps), field), {}, {
        valid: isSubmitted && !error,
        invalid: isSubmitted && error,
        feedback: (error === null || error === void 0 ? void 0 : error.message) || feedback
      }));
    }
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BaseField);

/***/ }),

/***/ 9079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ fields_TextareaField; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(5518);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 15 modules
var Form = __webpack_require__(2914);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(6968);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__(3489);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js + 15 modules
var OverlayTrigger = __webpack_require__(3174);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/atomic/controls/Textarea/index.jsx


var _excluded = ["labeled", "noBottomSpace"],
    _excluded2 = ["processing", "isValid", "isInvalid"],
    _excluded3 = ["labeled"],
    _excluded4 = ["labeled"],
    _excluded5 = ["name", "hint", "label", "loading", "labelSpace", "required", "noBottomSpace", "valid", "invalid", "feedback", "value", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var colors = theme/* theme.colors */.r.colors,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledGroup = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var labeled = _ref.labeled,
      noBottomSpace = _ref.noBottomSpace,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Textarea__StyledGroup",
  componentId: "sc-6wgbhw-0"
})(["position:relative;padding-top:", "px;margin-bottom:", "px;", ""], function (_ref2) {
  var labeled = _ref2.labeled;
  return labeled ? spaces.largeX : 0;
}, spaces.regular, function (_ref3) {
  var noBottomSpace = _ref3.noBottomSpace;
  return noBottomSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:0;"]);
});
var StyledLabel = (0,styled_components_browser_esm/* default */.ZP)(Form/* default.Label */.Z.Label).withConfig({
  displayName: "Textarea__StyledLabel",
  componentId: "sc-6wgbhw-1"
})(["position:absolute;top:0;left:", "px;margin:0;font-family:'Aeonik';font-size:", "px;font-style:normal;font-weight:400;line-height:150%;color:", ";span{color:", ";}"], spaces.smallest, fontSizes.regular, colors.gray[800], colors.orange[500]); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledControl = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref4, ref) {
  var processing = _ref4.processing,
      isValid = _ref4.isValid,
      isInvalid = _ref4.isInvalid,
      props = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Textarea__StyledControl",
  componentId: "sc-6wgbhw-2"
})(["min-height:48px;width:100%;resize:none;padding-top:", "px;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;border:1px solid ", ";border-radius:4px;background-color:", ";font-family:'Aeonik';font-size:", "px;font-style:normal;font-weight:400;line-height:150%;color:", ";caret-color:", ";&::placeholder{color:", ";}&:focus{border-color:", ";box-shadow:none;}&:focus-visible{outline:none;}&:disabled{background-color:", ";}", " ", " ", ";"], spaces.small - 2, spaces.small - 2, spaces.regular, spaces.regular, colors.gray[200], colors.white, fontSizes.regular, colors.gray[800], colors.blue[500], colors.gray[400], colors.blue[500], colors.gray[100], function (_ref5) {
  var isValid = _ref5.isValid;
  return isValid && (0,styled_components_browser_esm/* css */.iv)(["padding-right:", "px;border-color:", ";background-image:none;&:focus{border-color:", ";box-shadow:none;}"], spaces.regular, colors.gray[200], colors.blue[500]);
}, function (_ref6) {
  var isInvalid = _ref6.isInvalid;
  return isInvalid && (0,styled_components_browser_esm/* css */.iv)(["padding-right:", "px;border-color:", ";background-image:none;&:focus{border-color:", ";box-shadow:none;}"], spaces.regular, colors.orange[800], colors.blue[500]);
}, function (_ref7) {
  var processing = _ref7.processing;
  return processing && (0,styled_components_browser_esm/* css */.iv)(["padding-right:", "px;"], spaces.large6X);
});
var StyledSpinner = (0,styled_components_browser_esm/* default */.ZP)(function (_ref8) {
  var labeled = _ref8.labeled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref8, _excluded3);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, _objectSpread({}, props));
}).withConfig({
  displayName: "Textarea__StyledSpinner",
  componentId: "sc-6wgbhw-3"
})(["position:absolute;top:", "px;right:", "px;&.text-custom{color:", ";}", ""], spaces.largeX + (48 - 32) / 2, spaces.smallX, colors.gray[500], function (_ref9) {
  var labeled = _ref9.labeled;
  return !labeled && (0,styled_components_browser_esm/* css */.iv)(["top:", "px;"], (48 - 32) / 2);
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledIconContainer = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref10, ref) {
  var labeled = _ref10.labeled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref10, _excluded4);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Textarea__StyledIconContainer",
  componentId: "sc-6wgbhw-4"
})(["display:flex;position:absolute;top:", "px;right:", "px;", ""], spaces.largeX + (48 - 16) / 2, spaces.regular, function (_ref11) {
  var labeled = _ref11.labeled;
  return !labeled && (0,styled_components_browser_esm/* css */.iv)(["top:", "px;"], (48 - 16) / 2);
});
var StyledFeedback = (0,styled_components_browser_esm/* default */.ZP)(Form/* default.Control.Feedback */.Z.Control.Feedback).withConfig({
  displayName: "Textarea__StyledFeedback",
  componentId: "sc-6wgbhw-5"
})(["display:block;padding-left:", "px;font-family:'Aeonik';font-size:", "px;font-style:normal;font-weight:400;line-height:150%;&.processing-feedback{color:", ";}&.valid-feedback{color:", ";}&.invalid-feedback{color:", ";}"], spaces.smallest, fontSizes.regular, colors.gray[500], colors.blue[500], colors.orange[800]); // eslint-disable-next-line prettier/prettier, react/display-name

var Textarea = /*#__PURE__*/(0,react.forwardRef)(function (_ref12, ref) {
  var name = _ref12.name,
      hint = _ref12.hint,
      label = _ref12.label,
      loading = _ref12.loading,
      labelSpace = _ref12.labelSpace,
      required = _ref12.required,
      noBottomSpace = _ref12.noBottomSpace,
      valid = _ref12.valid,
      invalid = _ref12.invalid,
      feedback = _ref12.feedback,
      value = _ref12.value,
      onChange = _ref12.onChange,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref12, _excluded5);

  var overlayTriggerProps = (0,react.useMemo)(function () {
    var props = {
      placement: lib/* isMobile */.tq ? 'top' : 'right-start',
      delay: {
        show: 0,
        hide: 0
      },
      trigger: ['hover', 'focus'],
      overlay: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        id: "tooltip-".concat(name),
        className: "hintTooltip",
        children: hint
      })
    };

    if (!hint || lib/* isMobile */.tq) {
      props.show = false;
    }

    return props;
  }, [name, hint]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OverlayTrigger/* default */.Z, _objectSpread(_objectSpread({}, overlayTriggerProps), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledGroup, {
      labeled: Boolean(label || labelSpace),
      noBottomSpace: noBottomSpace,
      className: invalid ? 'custom-control-invalid' : '',
      children: [label && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLabel, {
        children: [label, label && required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "\xA0*"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledControl, _objectSpread(_objectSpread({}, restProps), {}, {
        ref: ref,
        as: "textarea",
        rows: 5,
        isValid: valid,
        isInvalid: invalid,
        processing: loading,
        value: value || '',
        onChange: onChange,
        "data-hj-allow": true
      })), loading && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSpinner, {
          animation: "border",
          variant: "custom",
          labeled: Boolean(label || labelSpace)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFeedback, {
          type: "processing",
          children: feedback
        })]
      }), !loading && valid && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconContainer, {
          labeled: Boolean(label || labelSpace),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.check */.F.check,
            color: colors.blue[500],
            height: 16,
            width: 16
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFeedback, {
          type: "valid",
          children: feedback
        })]
      }), !loading && invalid && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconContainer, {
          labeled: Boolean(label || labelSpace),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.close */.F.close,
            color: colors.orange[800],
            height: 16,
            width: 16
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFeedback, {
          type: "invalid",
          children: feedback
        })]
      })]
    })
  }));
});
/* harmony default export */ var controls_Textarea = (Textarea);
;// CONCATENATED MODULE: ./_components/atomic/fields/TextareaField/index.jsx


var TextareaField_excluded = ["name", "control", "rules", "feedback"];

function TextareaField_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TextareaField_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TextareaField_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TextareaField_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var TextareaField = function TextareaField(_ref) {
  var name = _ref.name,
      control = _ref.control,
      _ref$rules = _ref.rules,
      rules = _ref$rules === void 0 ? {} : _ref$rules,
      feedback = _ref.feedback,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, TextareaField_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
    name: name,
    control: control,
    rules: rules,
    render: function render(_ref2) {
      var field = _ref2.field,
          error = _ref2.fieldState.error,
          isSubmitted = _ref2.formState.isSubmitted;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(controls_Textarea, TextareaField_objectSpread(TextareaField_objectSpread(TextareaField_objectSpread({}, restProps), field), {}, {
        valid: isSubmitted && !error,
        invalid: isSubmitted && error,
        feedback: (error === null || error === void 0 ? void 0 : error.message) || feedback
      }));
    }
  });
};

/* harmony default export */ var fields_TextareaField = (TextareaField);

/***/ }),

/***/ 5820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
var StyledBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerContainer",
  componentId: "sc-13zc8xh-0"
})(["display:flex;justify-content:space-between;flex-direction:column;position:relative;align-items:center;max-width:", "px;padding-top:", "px;padding-bottom:", "px;@media ", "{padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;}"], spaces.large24X * 10 + 80, spaces.large12X - 2, spaces.large24X, devices.tablet, spaces.regular, spaces.regular, spaces.regular, spaces.regular);
var StyledBannerImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerImageContainer",
  componentId: "sc-13zc8xh-1"
})(["", " img{max-width:100%;max-height:100%;}"], function (_ref) {
  var width = _ref.width;
  return width && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["width:", "px;"], width);
});
var StyledBannerContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerContentContainer",
  componentId: "sc-13zc8xh-2"
})(["display:flex;flex-direction:column;justify-content:center;@media ", "{padding-right:0;width:100%;}"], devices.tablet);
var StyledBannerHeaderSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerHeaderSection",
  componentId: "sc-13zc8xh-3"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";text-align:center;@media ", "{font-size:", "px;margin-bottom:", "px;}"], spaces.large2X - 2, fontSizes.large11X, colors.gray[800], devices.tablet, fontSizes.large2X, spaces.large);
var StyledBannerSubHeaderSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerSubHeaderSection",
  componentId: "sc-13zc8xh-4"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";text-align:center;@media ", "{font-size:", "px;margin-bottom:", "px;}"], spaces.large9X, fontSizes.large, colors.gray[700], devices.tablet, fontSizes.regular, spaces.large3X);

var AboutBannerSection = function AboutBannerSection(_ref2) {
  var imgSrc = _ref2.imgSrc,
      header = _ref2.header,
      subHeader = _ref2.subHeader;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBannerContentContainer, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerHeaderSection, {
        children: header
      }), subHeader && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerSubHeaderSection, {
        children: subHeader
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerImageContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
          srcSet: imgSrc,
          type: "image/png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          src: imgSrc,
          alt: "Banner image"
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AboutBannerSection);

/***/ }),

/***/ 2410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["moreSpace", "imgTopDesktopPosition"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.spaces */ .r.spaces;
var StyledBottomBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerContainer",
  componentId: "sc-rgywhc-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;width:100%;margin-bottom:", "px;margin-top:", "px;@media ", "{margin-bottom:", "px;margin-top:", "px;}"], spaces.large24X, spaces.large24X, devices.tablet, spaces.large9X, spaces.large9X);
var StyledDisclaimer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledDisclaimer",
  componentId: "sc-rgywhc-1"
})(["max-width:", "px;width:100%;text-align:center;margin-top:", "px;font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";@media ", "{padding-left:", "px;padding-right:", "px;}"], spaces.large24X * 10 + 80, spaces.regular, fontSizes.regular, colors.gray[500], devices.tablet, spaces.regular, spaces.regular); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledBottomBannerSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var moreSpace = _ref.moreSpace,
      imgTopDesktopPosition = _ref.imgTopDesktopPosition,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerSection",
  componentId: "sc-rgywhc-2"
})(["display:flex;justify-content:space-between;background:", ";border-radius:40px;max-width:", "px;width:100%;padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;.header{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-bottom:", "px;margin-right:", "px;}.footer{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";display:flex;flex-direction:row;justify-content:space-between;align-items:center;}.column1{padding-right:", "px;}.column2{margin-top:", ";margin-bottom:-60px;margin-right:-55px;}@media ", "{margin-left:0;margin-right:0;border-radius:0px;box-shadow:0px 30px 80px rgba(0,0,0,0.05);padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;align-items:center;.header{font-size:", "px;line-height:150%;margin-bottom:", "px;margin-right:", "px;}.footer{font-size:", "px;line-height:24px;flex-direction:column;align-items:flex-start;gap:10px;}.column2{margin:0;img{height:120px;}}}"], colors.blue[600], spaces.large24X * 10 + 80, spaces.large14X, spaces.large14X, spaces.large9X, spaces.large9X, fontSizes.large11X, colors.white, function (_ref2) {
  var moreSpace = _ref2.moreSpace;
  return moreSpace ? spaces.large4X : spaces.medium;
}, spaces.large14X, fontSizes.large, colors.blue[100], spaces.regular, function (_ref3) {
  var imgTopDesktopPosition = _ref3.imgTopDesktopPosition;
  return imgTopDesktopPosition || 0;
}, devices.tablet, spaces.regular, spaces.regular, spaces.large, spaces.large, fontSizes.large, function (_ref4) {
  var moreSpace = _ref4.moreSpace;
  return moreSpace ? spaces.regular : spaces.smallX;
}, spaces.smallX, fontSizes.regular);

var BottomBannerSection = function BottomBannerSection(_ref5) {
  var header = _ref5.header,
      footer = _ref5.footer,
      imgSrc = _ref5.imgSrc,
      imgTopDesktopPosition = _ref5.imgTopDesktopPosition,
      moreSpace = _ref5.moreSpace,
      disclaimer = _ref5.disclaimer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerSection, {
      imgTopDesktopPosition: imgTopDesktopPosition,
      moreSpace: moreSpace,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "column1",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "header",
          children: header
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "footer",
          children: footer
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "column2",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
            srcSet: imgSrc,
            type: "image/png"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: imgSrc,
            alt: "Banner image"
          })]
        })
      })]
    }), disclaimer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDisclaimer, {
      children: "All information submitted to Trademark Genius shall be regarded as strictly confidential. Trademark Genius will not reveal any intellectual property information to any organization other than as necessary for submission to the USPTO."
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BottomBannerSection);

/***/ }),

/***/ 2238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_TrustPilotSection; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/atomic/TrustCard/index.jsx






var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var devices = theme/* theme.devices */.r.devices,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    colors = theme/* theme.colors */.r.colors,
    spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledTrustCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustCard",
  componentId: "sc-xqhkuu-0"
})(["height:100%;justify-content:space-between;display:inline-flex;flex-direction:column;align-items:flex-start;padding:", "px ", "px ", "px ", "px;background:linear-gradient( 180deg,", " 0%,rgba(249,250,251,0) 100% );border-radius:30px;flex:none;order:0;align-self:stretch;flex-grow:1;width:100%;@media ", "{padding:", "px;.headerSection{padding:0px ", "px;font-size:", "px;line-height:150%;}.subHeaderSection{padding:0px ", "px;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;}}"], spaces.large2X - 2, spaces.medium, spaces.medium, spaces.large2X - 2, colors.gray[100], devices.tablet, spaces.medium, spaces.regular, fontSizes.large2X, spaces.regular, fontSizes.regular, spaces.smallX, spaces.large2X);
var StyledTrustDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustDescription",
  componentId: "sc-xqhkuu-1"
})(["margin-top:", "px;margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";text-align:justify;align-self:stretch;@media ", "{font-size:", "px;text-align:left;}"], spaces.medium, spaces.medium, fontSizes.large, colors.gray[800], devices.tablet, fontSizes.regular);
var StyledTrustStarDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustStarDescription",
  componentId: "sc-xqhkuu-2"
})(["text-align:left;@media ", "{text-align:center;}"], devices.tablet);
var StyledTrustAuthor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustAuthor",
  componentId: "sc-xqhkuu-3"
})(["font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;text-transform:uppercase;color:", ";@media ", "{text-align:center;}"], fontSizes.large, colors.gray[800], devices.tablet);
var StyledTrustCustomer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustCustomer",
  componentId: "sc-xqhkuu-4"
})(["font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";@media ", "{text-align:center;}"], fontSizes.regular, colors.gray[500], devices.tablet);

var TrustCard = function TrustCard(_ref) {
  var description = _ref.description,
      author = _ref.author;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTrustCard, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustStarDescription, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            srcSet: "".concat(publicRuntimeConfig.basePath, "/images/5-star.svg"),
            type: "image/png"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(publicRuntimeConfig.basePath, "/images/5-star.svg"),
            alt: ""
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustDescription, {
        children: description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustAuthor, {
        children: author
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustCustomer, {
        children: "Trademark Genius Customer"
      })]
    })]
  });
};

/* harmony default export */ var atomic_TrustCard = (TrustCard);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
;// CONCATENATED MODULE: ./_constants/trustPilots.js
var trustPilots = [{
  author: 'Mark D.',
  description: 'Trademark Genius helped register my companies trademark. The process was simple, their customer service was excellent, and my trademark was registered without any issues. Highly recommend Trademark Genius.'
}, {
  author: 'Terry F.',
  description: 'Got my trademark registered with USPTO without any issues. Their dashboard is a great tool and helped me track the progress of my application all the way to completion. Will use them again for any other TM needs.'
}, {
  author: 'Lisa N.',
  description: 'My trademark registration was a unique situation that required some extra work, the team helped guide me through this daunting process and got my application submit to USPTO (and was approved without issues) Thanks TMG!'
}, {
  author: 'Kelly T.',
  description: 'I contacted Trademark Genius after running into many issues trying to register my companies trademark myself. They helped solve every issue i ran into. Would definitely recommend spending the money to have professionals handle this process.'
}, {
  author: 'Jacob J.',
  description: 'Submit my application, they reviewed it and identified some mistakes that would have caused a rejection. We fixed those and my trademark was approved. A+'
}, {
  author: 'Guy H.',
  description: 'Decided to use Trademark Genius to trademark my business name. The process was easy with no unexpected issues. I will be using them again for any future trademarking needs.'
}, {
  author: 'Esther H.',
  description: 'The staff here knows what they are doing, I used them to file 2 trademarks this year, both were approved by the USPTO. I would recommend them to anyone looking to file without issues.'
}];
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(1911);
// EXTERNAL MODULE: ./_hooks/index.js + 2 modules
var _hooks = __webpack_require__(5125);
;// CONCATENATED MODULE: ./_components/composed/sections/TrustPilotSection/index.jsx
















var TrustPilotSection_getConfig = config_default()(),
    TrustPilotSection_publicRuntimeConfig = TrustPilotSection_getConfig.publicRuntimeConfig;

var TrustPilotSection_colors = theme/* theme.colors */.r.colors,
    TrustPilotSection_devices = theme/* theme.devices */.r.devices,
    TrustPilotSection_fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    TrustPilotSection_spaces = theme/* theme.spaces */.r.spaces;
swiper_esm/* default.use */.ZP.use([swiper_esm/* Navigation */.W_]);
var StyledTrustPilotSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledTrustPilotSection",
  componentId: "sc-jnrgeg-0"
})(["max-width:", "px;display:flex;gap:30px;.swiper{display:flex;flex-direction:column;}.swiper-slide{width:31.5%;}@media ", "{padding-left:", "px;padding-right:", "px;}@media ", "{margin-left:", "px;margin-right:", "px;.swiper-slide{width:100%;}}"], TrustPilotSection_spaces.large24X * 10 + 80, TrustPilotSection_devices.laptopM, TrustPilotSection_spaces.large2X, TrustPilotSection_spaces.large2X, TrustPilotSection_devices.tablet, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular);
var TrustPilotSection_StyledTrustCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledTrustCard",
  componentId: "sc-jnrgeg-1"
})(["height:100%;"]);
var StyledSliderNavigationButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledSliderNavigationButtons",
  componentId: "sc-jnrgeg-2"
})(["height:100%;align-items:end;display:flex;justify-content:center;gap:", "px;.navButton{cursor:pointer;}.swiper-button-disabled{cursor:initial;svg{path{fill:", ";}}}@media ", "{padding-right:0px;svg{width:24px;}}"], TrustPilotSection_spaces.large2X, TrustPilotSection_colors.gray[500], TrustPilotSection_devices.tablet);
var StyledSliderNavigation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledSliderNavigation",
  componentId: "sc-jnrgeg-3"
})(["align-items:flex-end;display:flex;justify-content:space-between;margin-top:", "px;margin-left:9%;margin-right:9%;@media ", "{flex-direction:column;align-items:center;gap:", "px;margin-top:", "px;margin-left:", "px;margin-right:", "px;}"], TrustPilotSection_spaces.large7X - 2, TrustPilotSection_devices.tablet, TrustPilotSection_spaces.large2X - 2, TrustPilotSection_spaces.large2X, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular);
var StyledTrustLogoSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledTrustLogoSection",
  componentId: "sc-jnrgeg-4"
})(["flex-direction:column;.trustLogoReviews{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";}@media ", "{align-items:center;display:flex;.trustLogoReviews{text-align:center;padding-left:", "px;padding-right:", "px;}}"], TrustPilotSection_fontSizes.regular, TrustPilotSection_colors.gray[500], TrustPilotSection_devices.tablet, TrustPilotSection_spaces.large2X - 2, TrustPilotSection_spaces.large2X - 2);
var StyledSectionWithHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledSectionWithHeader",
  componentId: "sc-jnrgeg-5"
})(["margin-top:", "px;display:flex;flex-direction:column;.headerSection{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-left:9%;margin-right:9%;}.subHeaderSection{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-left:9%;margin-right:9%;}@media ", "{margin-top:", "px;margin-bottom:", "px;margin-left:0;margin-right:0;.headerSection{font-size:", "px;line-height:150%;margin-left:", "px;margin-right:", "px;}.subHeaderSection{margin-left:", "px;margin-right:", "px;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;}}"], TrustPilotSection_spaces.large24X, TrustPilotSection_fontSizes.large11X, TrustPilotSection_colors.gray[800], TrustPilotSection_fontSizes.large, TrustPilotSection_spaces.medium, TrustPilotSection_spaces.large6X + 2, TrustPilotSection_colors.gray[700], TrustPilotSection_devices.tablet, TrustPilotSection_spaces.large9X, TrustPilotSection_spaces.large9X, TrustPilotSection_fontSizes.large2X, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular, TrustPilotSection_fontSizes.regular, TrustPilotSection_spaces.smallX, TrustPilotSection_spaces.large2X);

var TrustPilotSection = function TrustPilotSection(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      elRef = _ref.elRef;

  var _useSwiperRef = (0,_hooks/* useSwiperRef */.S)(),
      _useSwiperRef2 = (0,slicedToArray/* default */.Z)(_useSwiperRef, 2),
      nextEl = _useSwiperRef2[0],
      nextElRef = _useSwiperRef2[1];

  var _useSwiperRef3 = (0,_hooks/* useSwiperRef */.S)(),
      _useSwiperRef4 = (0,slicedToArray/* default */.Z)(_useSwiperRef3, 2),
      prevEl = _useSwiperRef4[0],
      prevElRef = _useSwiperRef4[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSectionWithHeader, {
    ref: elRef,
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headerSection",
      children: title
    }), subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subHeaderSection",
      children: subTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustPilotSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        spaceBetween: 32,
        slidesPerView: "auto",
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        children: trustPilots.map(function (trustPilot, idx) {
          var author = trustPilot.author,
              description = trustPilot.description;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TrustPilotSection_StyledTrustCard, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atomic_TrustCard, {
                author: author,
                description: description
              })
            })
          }, "step:".concat(idx));
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSliderNavigation, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTrustLogoSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              srcSet: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/trustpilot-logo.svg"),
              type: "image/png"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/trustpilot-logo.svg"),
              alt: ""
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            marginTop: '14px',
            marginBottom: '5px'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              srcSet: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/5-star.svg"),
              type: "image/png"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/5-star.svg"),
              alt: ""
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "trustLogoReviews",
          children: "4.7 out of 5 based on 55012 reviews. Showing our 4 and 5 stars reviews."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSliderNavigationButtons, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: prevElRef,
          className: "navButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.arrowLeft */.F.arrowLeft,
            color: TrustPilotSection_colors.blue[500],
            height: 30,
            width: 30
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: nextElRef,
          className: "navButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
            color: TrustPilotSection_colors.blue[500],
            height: 30,
            width: 30
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var sections_TrustPilotSection = (TrustPilotSection);

/***/ }),

/***/ 5125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ usePrevious; },
  "S": function() { return /* reexport */ useSwiperRef; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./_hooks/usePrevious.js

var usePrevious = function usePrevious(value) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};
;// CONCATENATED MODULE: ./_hooks/useSwiperRef.js

var useSwiperRef = function useSwiperRef() {
  var _useState = (0,react.useState)(null),
      wrapper = _useState[0],
      setWrapper = _useState[1];

  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    setWrapper(ref.current);
  }, []);
  return [wrapper, ref];
};
;// CONCATENATED MODULE: ./_hooks/index.js




/***/ }),

/***/ 1970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContactUs; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./_config/index.js
var _config = __webpack_require__(8002);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_constants/routes.js
var routes = __webpack_require__(672);
// EXTERNAL MODULE: ./_constants/forms.js
var _constants_forms = __webpack_require__(5918);
// EXTERNAL MODULE: ./_redux/contactUs/slice.js
var slice = __webpack_require__(7787);
;// CONCATENATED MODULE: ./_redux/contactUs/selector.js
var selectResult = function selectResult(state) {
  return state.contactUs.result;
};
var selectError = function selectError(state) {
  return state.contactUs.error;
};
var selectLoading = function selectLoading(state) {
  return state.contactUs.loading;
};
// EXTERNAL MODULE: ./_components/composed/sections/TrustPilotSection/index.jsx + 2 modules
var TrustPilotSection = __webpack_require__(2238);
// EXTERNAL MODULE: ./_components/composed/sections/AboutBannerSection/index.jsx
var AboutBannerSection = __webpack_require__(5820);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 15 modules
var Form = __webpack_require__(2914);
// EXTERNAL MODULE: ./_helpers/forms/fields.js + 2 modules
var fields = __webpack_require__(2673);
// EXTERNAL MODULE: ./_components/atomic/layouts/form/index.js + 8 modules
var layouts_form = __webpack_require__(2890);
// EXTERNAL MODULE: ./_components/atomic/fields/BaseField/index.jsx
var BaseField = __webpack_require__(2258);
// EXTERNAL MODULE: ./_components/atomic/fields/TextareaField/index.jsx + 1 modules
var TextareaField = __webpack_require__(9079);
// EXTERNAL MODULE: ./_components/atomic/Button/index.jsx
var Button = __webpack_require__(8509);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/composed/forms/ContactUsForm/index.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var colors = theme/* theme.colors */.r.colors,
    devices = theme/* theme.devices */.r.devices,
    spaces = theme/* theme.spaces */.r.spaces;
var StyledContactUsForm = (0,styled_components_browser_esm/* default */.ZP)(Form/* default */.Z).withConfig({
  displayName: "ContactUsForm__StyledContactUsForm",
  componentId: "sc-9cuwoi-0"
})(["max-width:", "px;width:100%;display:flex;flex-direction:column;justify-content:flex-start;padding:", "px;background:#ffffff;box-shadow:0px 30px 80px rgba(0,0,0,0.1);border-radius:30px;@media ", "{padding:", "px;box-shadow:unset;}"], spaces.large24X * 5 + 80, spaces.largeX + 2, devices.tablet, spaces.regular);
var SendButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsForm__SendButtonContainer",
  componentId: "sc-9cuwoi-1"
})(["text-align:right;"]);

var ContactUsForm = function ContactUsForm(_ref) {
  var error = _ref.error,
      success = _ref.success,
      submitDisabled = _ref.submitDisabled,
      onSubmit = _ref.onSubmit;

  var _useForm = (0,index_esm/* useForm */.cI)({
    reValidateMode: 'onBlur'
  }),
      control = _useForm.control,
      isValidating = _useForm.formState.isValidating,
      reset = _useForm.reset,
      handleSubmit = _useForm.handleSubmit;

  var _useState = (0,react.useState)(false),
      emailVerifying = _useState[0],
      setEmailVerifying = _useState[1];

  (0,react.useEffect)(function () {
    if (success) {
      reset();
    }
  }, [success, reset]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContactUsForm, {
    noValidate: true,
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BaseField/* default */.Z, _objectSpread(_objectSpread({}, (0,fields/* getFieldProps */.X)(_constants_forms/* FIELDS_KEYS.fullName */.mC.fullName)), {}, {
      control: control
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(BaseField/* default */.Z, _objectSpread(_objectSpread({}, (0,fields/* getFieldProps */.X)(_constants_forms/* FIELDS_KEYS.email */.mC.email, {
      validationOptions: {
        setValidating: setEmailVerifying
      }
    })), {}, {
      control: control,
      loading: emailVerifying,
      feedback: emailVerifying ? 'Verifying...' : undefined
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(BaseField/* default */.Z, _objectSpread(_objectSpread({}, (0,fields/* getFieldProps */.X)(_constants_forms/* FIELDS_KEYS.subject */.mC.subject)), {}, {
      control: control
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(TextareaField/* default */.Z, _objectSpread(_objectSpread({}, (0,fields/* getFieldProps */.X)(_constants_forms/* FIELDS_KEYS.message */.mC.message)), {}, {
      control: control
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(SendButtonContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        type: "submit",
        large: true,
        disabled: emailVerifying || isValidating || submitDisabled,
        color: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.send */.F.send,
          color: colors.white
        }),
        children: "Send Message"
      })
    }), success && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layouts_form/* Divider */.iz, {
        size: theme/* theme.spaces.medium */.r.spaces.medium
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(layouts_form/* Paragraph */.nv, {
        color: theme/* theme.colors.gray.500 */.r.colors.gray[500],
        bold: true,
        noBottomSpace: true,
        children: "Thank you for your question. Our agents will respond to your inquiry as quickly as possible."
      })]
    }), error && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layouts_form/* Divider */.iz, {
        size: theme/* theme.spaces.medium */.r.spaces.medium
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(layouts_form/* Paragraph */.nv, {
        color: theme/* theme.colors.orange.800 */.r.colors.orange[800],
        bold: true,
        noBottomSpace: true,
        children: error === null || error === void 0 ? void 0 : error.message
      })]
    })]
  });
};

/* harmony default export */ var forms_ContactUsForm = (ContactUsForm);
// EXTERNAL MODULE: ./_components/composed/sections/BottomBannerSection/index.jsx
var BottomBannerSection = __webpack_require__(2410);
;// CONCATENATED MODULE: ./_helpers/common.js

var getHostname = function getHostname() {
  var fallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (true) {
    return "".concat(window.location.hostname).concat(_config/* config.basePath */.v.basePath);
  }

  return fallback;
};
;// CONCATENATED MODULE: ./_components/composed/pages/ContactUsPage/index.jsx



var _config$phone;

var _excluded = ["size", "rotate", "top", "bottom", "left", "right"],
    _excluded2 = ["top", "bottom", "left", "right"];

function ContactUsPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ContactUsPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ContactUsPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContactUsPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var ContactUsPage_colors = theme/* theme.colors */.r.colors,
    ContactUsPage_devices = theme/* theme.devices */.r.devices,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    ContactUsPage_spaces = theme/* theme.spaces */.r.spaces;

var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var StyledContactUsPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__StyledContactUsPage",
  componentId: "sc-o1qkku-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;@media ", "{display:block;}"], ContactUsPage_devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledCircle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      rotate = _ref.rotate,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", ContactUsPage_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "ContactUsPage__StyledCircle",
  componentId: "sc-o1qkku-1"
})(["position:absolute;background:", ";border-radius:50%;opacity:0.1;z-index:-1;", " ", " ", " ", " ", " ", " @media ", "{display:none;}"], "linear-gradient(180deg, ".concat(theme/* theme.colors.blue.500 */.r.colors.blue[500], " 0%, rgba(46, 144, 250, 0) 100%)"), function (_ref2) {
  var top = _ref2.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref3) {
  var bottom = _ref3.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref4) {
  var left = _ref4.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref5) {
  var right = _ref5.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref6) {
  var rotate = _ref6.rotate;
  return rotate && (0,styled_components_browser_esm/* css */.iv)(["transform:", ";"], "rotate(".concat(rotate, "deg)"));
}, function (_ref7) {
  var size = _ref7.size;
  return size && (0,styled_components_browser_esm/* css */.iv)(["width:", "px;height:", "px;"], size, size);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.devices.tablet;
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledImageContainer = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref9, ref) {
  var top = _ref9.top,
      bottom = _ref9.bottom,
      left = _ref9.left,
      right = _ref9.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", ContactUsPage_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "ContactUsPage__StyledImageContainer",
  componentId: "sc-o1qkku-2"
})(["position:absolute;z-index:-1;", " ", " ", " ", " @media ", "{display:none;}"], function (_ref10) {
  var top = _ref10.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref11) {
  var bottom = _ref11.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref12) {
  var left = _ref12.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref13) {
  var right = _ref13.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.devices.tablet;
});
var ItemGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__ItemGroup",
  componentId: "sc-o1qkku-3"
})(["display:flex;justify-content:center;flex-direction:row;gap:", "px;@media ", "{flex-direction:column;gap:10px;}"], ContactUsPage_spaces.large4X, ContactUsPage_devices.tablet);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__Item",
  componentId: "sc-o1qkku-4"
})(["display:flex;align-items:center;gap:", "px;@media ", "{gap:10px;}"], ContactUsPage_spaces.regular, ContactUsPage_devices.tablet);
var RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__RightWrapper",
  componentId: "sc-o1qkku-5"
})(["display:flex;flex-direction:column;align-items:flex-start;"]);
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__HeaderWrapper",
  componentId: "sc-o1qkku-6"
})(["font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;color:", ";@media ", "{font-size:", "px;}"], fontSizes.regular, ContactUsPage_colors.gray[600], ContactUsPage_devices.tablet, fontSizes.small);
var LinkWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__LinkWrapper",
  componentId: "sc-o1qkku-7"
})(["font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:150%;color:", ";a{text-decoration:none;color:", ";}@media ", "{font-size:", "px;}"], fontSizes.large, ContactUsPage_colors.blue[500], ContactUsPage_colors.blue[500], ContactUsPage_devices.tablet, fontSizes.regular);
var RoundWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__RoundWrapper",
  componentId: "sc-o1qkku-8"
})(["background:#d1e9ff;border-radius:50px;height:56px;width:56px;display:flex;align-items:center;justify-content:center;@media ", "{height:52px;width:52px;}"], ContactUsPage_devices.tablet);
var items = [{
  header: 'CALL',
  link: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: "tel:".concat(_config/* config.phone */.v.phone),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* PatternFormat */.HH, {
      value: (_config$phone = _config/* config.phone */.v.phone) === null || _config$phone === void 0 ? void 0 : _config$phone.substring(2),
      displayType: "text",
      format: "(###) ###-####"
    })
  }),
  icon: icons/* ICONS_ALIASES.callCalling */.F.callCalling
}, {
  header: 'EMAIL',
  link: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: "mailto:".concat(_config/* config.email */.v.email, "?subject=Mail from Contact Us Trademark Site"),
    children: "support@trademark-genius.com"
  }),
  icon: icons/* ICONS_ALIASES.sms */.F.sms
}, {
  header: 'HOUR',
  link: 'Monday - Friday: 9am - 5pm PST',
  icon: icons/* ICONS_ALIASES.clock */.F.clock
}];

var ContactUsPage = function ContactUsPage() {
  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();
  var result = (0,es/* useSelector */.v9)(selectResult);
  var error = (0,es/* useSelector */.v9)(selectError);
  var loading = (0,es/* useSelector */.v9)(selectLoading);
  var handleSubmit = (0,react.useCallback)(function (values) {
    if (values) {
      dispatch((0,slice/* sendMessage */.bG)({
        name: values[_constants_forms/* FIELDS_KEYS.fullName */.mC.fullName],
        email: values[_constants_forms/* FIELDS_KEYS.email */.mC.email],
        phone: values[_constants_forms/* FIELDS_KEYS.phone */.mC.phone],
        domain: getHostname(),
        subject: values[_constants_forms/* FIELDS_KEYS.subject */.mC.subject],
        message: values[_constants_forms/* FIELDS_KEYS.message */.mC.message]
      }));
    }
  }, [dispatch]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContactUsPage, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AboutBannerSection/* default */.Z, {
      header: "Contact us",
      imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/contactus.svg"),
      subHeader: /*#__PURE__*/(0,jsx_runtime.jsx)(ItemGroup, {
        children: items.map(function (item, idx) {
          var header = item.header,
              link = item.link,
              icon = item.icon;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RoundWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
                alias: icon,
                color: ContactUsPage_colors.blue[500],
                width: 24,
                height: 24
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RightWrapper, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderWrapper, {
                children: header
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrapper, {
                children: link
              })]
            })]
          }, "item:".concat(idx));
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(forms_ContactUsForm, {
      error: error,
      success: result,
      submitDisabled: loading,
      onSubmit: handleSubmit
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustPilotSection/* default */.Z, {
      title: "Customer Reviews & Testimonials",
      subTitle: "See why others are choosing Trademark Genius!"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBannerSection/* default */.Z, {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Don't wait, Protect Your Brand now"
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: ContactUsPage_colors.blue[500]
        }),
        color: ContactUsPage_colors.white,
        onClick: function onClick() {
          return router.push(routes/* ROUTES.trademarkRegistration */.Z.trademarkRegistration);
        },
        textColor: ContactUsPage_colors.blue[500],
        hoverColor: ContactUsPage_colors.white,
        hoverTextColor: ContactUsPage_colors.blue[500],
        children: "Start Registering Now"
      }),
      imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/trademark-registration-bottom.svg"),
      imgTopDesktopPosition: "-130px",
      moreSpace: true,
      disclaimer: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: -90,
      left: -63,
      top: -199
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: -44,
      top: 285,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: -90,
      left: -232,
      top: 'calc(40% - 30px)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: 65,
      top: 'calc(53% + 20px)',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: 90,
      right: -199,
      top: 155
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      right: -66,
      top: 78,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    })]
  });
};

/* harmony default export */ var pages_ContactUsPage = (ContactUsPage);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/contactus.js





function ContactUs() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "Contact Us"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages_ContactUsPage, {})]
  });
}

/***/ }),

/***/ 2613:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contactus",
      function () {
        return __webpack_require__(1970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6592);
/* harmony import */ var _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3825);
/* harmony import */ var _triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4509);
/* harmony import */ var _TransitionWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9337);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);








const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
const fadeStyles = {
  [react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERING */ .d0]: 'show',
  [react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERED */ .cn]: 'show'
};
const Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  className,
  children,
  transitionClasses = {},
  ...props
}, ref) => {
  const handleEnter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((node, isAppearing) => {
    (0,_triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(node);
    props.onEnter == null ? void 0 : props.onEnter(node, isAppearing);
  }, [props]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TransitionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    ref: ref,
    addEndListener: _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    ...props,
    onEnter: handleEnter,
    childRef: children.ref,
    children: (status, innerProps) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, {
      ...innerProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
    })
  });
});
Fade.defaultProps = defaultProps;
Fade.displayName = 'Fade';
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 6968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);




const Spinner = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  variant,
  animation = 'border',
  size,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'spinner');
  const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
  });
});
Spinner.displayName = 'Spinner';
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);

/***/ }),

/***/ 6611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createWithBsPrefix; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/camelize.js
var rHyphen = /-(.)/g;
function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js





const pascalCase = str => str[0].toUpperCase() + camelize(str).slice(1);
// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
function createWithBsPrefix(prefix, {
  displayName = pascalCase(prefix),
  Component,
  defaultProps
} = {}) {
  const BsComponent = /*#__PURE__*/react.forwardRef(({
    className,
    bsPrefix,
    as: Tag = Component || 'div',
    ...props
  }, ref) => {
    const resolvedPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, prefix);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
      ref: ref,
      className: classnames_default()(className, resolvedPrefix),
      ...props
    });
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}

/***/ }),

/***/ 7150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ch": function() { return /* reexport */ useUncontrolled; },
  "$c": function() { return /* reexport */ useUncontrolledProp; }
});

// UNUSED EXPORTS: uncontrollable

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(1143);
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/utils.js


var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) { var handler; }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/hook.js



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = (0,react.useRef)(propValue !== undefined);

  var _useState = (0,react.useState)(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, (0,react.useCallback)(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}


function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[defaultKey(fieldName)],
        propsValue = _ref[fieldName],
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, [defaultKey(fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return (0,esm_extends/* default */.Z)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}
;// CONCATENATED MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function react_lifecycles_compat_es_polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/uncontrollable.js



var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";




function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = Utils.canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(canAcceptRef || !methods.length) ?  false ? 0 : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: _extends(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[Utils.defaultKey(key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: _extends(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!Utils.isProp(props, key) && Utils.isProp(prevProps, key)) {
          nextState.values[key] = props[Utils.defaultKey(key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = _objectWithoutPropertiesLoose(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return React.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(React.Component);

  polyfill(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = _extends({
    innerRef: function innerRef() {}
  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (React.forwardRef) {
    WrappedComponent = React.forwardRef(function (props, ref) {
      return React.createElement(UncontrolledComponent, _extends({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/index.js



/***/ }),

/***/ 7462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9460,9707,7910,8999,8127,2890,2673,9774,2888,179], function() { return __webpack_exec__(2613); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);